import { PopupProviderContext, PopupProviderOpts } from 'app/components/utils/popup';
import { useContext } from 'react';

/**
 * Hook for rendering stuff in a popup.
 *
 * @returns A PopupProvider that can be used to enqueue popups
 */
export const usePopup = (): PopupProviderOpts => {
  return useContext(PopupProviderContext);
};
